import { isWindowAvailable } from 'utils/browser';

export const yieldToMain = async (): Promise<void> => {
  if (!isWindowAvailable) {
    return Promise.resolve();
  }

  return new Promise<void>(resolve => {
    window.requestAnimationFrame(() => {
      window.setTimeout(() => {
        resolve();
      }, 0);
    });
  });
};
